<template>
  <div>
    <div class="title-bar">
      <h1>{{ isUpdate ? 'Редактировать Вопрос/Ответ' : 'Создать Вопрос/Ответ' }}</h1>

      <div class="title-bar__button-wrapper">
        <router-link class="button-wrapper-link" :to="{name: 'FAQList'}">
          <el-button type="info">
            <i class="fas fa-list" /> Список
          </el-button>
        </router-link>

        <el-button type="primary" @click="$refs.form.onSubmit()">
          Сохранить
        </el-button>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">
        <Form ref="form" />
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/components/help-center/faq/Form'

export default {
  name: 'CreateUpdate',
  metaInfo: {
    title: 'Создать/Редактировать FAQ',
  },
  components: {Form},
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateFAQ'
    },
  },
}
</script>

